module.exports = __webpack_public_path__ + "img/773.9f70a7df.jpg";